import { formatDateTime } from './formatDateTime';

import { LUXON_FORMAT } from '../constants';

export function formatTime(isoDateTime, format = LUXON_FORMAT.TIME) {
  return formatDateTime(isoDateTime, format);
}
